import {hasNLO, isNoteLinkedGroup} from 'notebook/TypePredicates';
import {Note, NoteLinkedObject, NotePart} from 'notebook/util/NoteUtilConstants';

import {NoteLinkedGroup} from '../groups/NoteLinkedGroupConstants';

type MapNLO = (nlo: NoteLinkedObject) => NoteLinkedObject;

/**
 * Replace every NoteLinkedObject with mapNLO(noteLinkedObject) even those nested inside a NoteLinkedGroup
 */
export function mapNLOInNote<T extends Note>(note: T, mapNLO: MapNLO): T {
  return {
    ...note,
    noteParts: mapNLOInNoteParts(note.noteParts, mapNLO),
  };
}

function mapNLOInNoteLinkedGroup<T>(group: NoteLinkedGroup<T>, mapNLO: MapNLO): NoteLinkedGroup<T> {
  return {
    ...group,
    containedNoteParts: mapNLOInNoteParts(group.containedNoteParts, mapNLO),
  };
}

function mapNLOInNoteParts(noteParts: Array<NotePart>, mapNLO: MapNLO): Array<NotePart> {
  return noteParts.map((notePart) => mapNLOInNotePart(notePart, mapNLO));
}

function mapNLOInNotePart(notePart: NotePart, mapNLO: MapNLO): NotePart {
  if (!hasNLO(notePart)) {
    return notePart;
  }
  let newItem = mapNLO(notePart.item);
  if (isNoteLinkedGroup(newItem)) {
    newItem = mapNLOInNoteLinkedGroup(newItem, mapNLO);
  }
  return {
    ...notePart,
    item: newItem,
  };
}
